import { store } from '@remote/store'
import { globalDisk } from '@remote/store/hezi-file/disk'
import { toast } from '@remote/utils/dialog'

// true 异常， false 正常
const deviceAbnormalMessage = '设备已离线，暂不支持操作'
export const checkDeviceState = (silent?:boolean) => {
  const isAbnormal = store.state.status !== 1 && store.state.loading === 0
  if (isAbnormal) !silent && toast({type: 'error', message: deviceAbnormalMessage})
  return isAbnormal ? deviceAbnormalMessage : ''
}

// true 异常， false 正常
const diskAbnormalMessage = '磁盘异常，暂不支持操作'
export const checkDiskState = (silent?: boolean) => {
  const isAbnormal = globalDisk.diskException
  if (isAbnormal) !silent && toast({type: 'error', message: diskAbnormalMessage})
  return isAbnormal ? diskAbnormalMessage : ''
}

// true 异常， false 正常
const networkAbnormalMessage = '网络异常，暂不支持操作'
export const checkNetworkState = (silent?: boolean) => {
  const isAbnormal = !navigator.onLine
  if (isAbnormal) !silent && toast({type: 'error', message: networkAbnormalMessage})
  return isAbnormal ? networkAbnormalMessage : ''
}

// true 异常， false 正常
export const checkState = (network = true, device = true, disk = true, silent?: boolean) => {
  if (network && checkNetworkState(silent)) return networkAbnormalMessage
  if (device && checkDeviceState(silent)) return deviceAbnormalMessage
  if (disk && checkDiskState(silent)) return diskAbnormalMessage
  return ''
}